import { ReactNode } from "react";
import styles from "../aic.module.css";
import { AitRowHeaderColumnsAdd } from "./AitRowHeaderColumnsAdd";
import { AitRowHeaderColumnsRemove } from "./AitRowHeaderColumnsRemove";
import { useTableContext } from "./TableContextProvider";

/**
 * Display and control the number of row header columns in the table.
 */
export const AitRowHeaderColumns = (): ReactNode => {
  const { state } = useTableContext();
  const rowHeaderColumns =
    state?.processedTableData?.rowHeaderColumns !== undefined
      ? state.processedTableData.rowHeaderColumns
      : 1;

  return !state ? null : (
    <div className={styles.aiwBodyRow}>
      <div className={styles.aioLabel}>Row headers: </div>
      <div
        aria-label="Row headers"
        role="status"
        className={styles.aioRoValue}
      >
        {rowHeaderColumns}
      </div>
      <div className={[styles.aioxButtonHolder, styles.padding2].join(" ")}>
        <AitRowHeaderColumnsAdd />
        <AitRowHeaderColumnsRemove />
      </div>
    </div>
  );
};

AitRowHeaderColumns.displayName = "AitRowHeaderColumns";
